import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import { CustomTextField } from '../../../../../components/CustomTextField';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import ArrowForwardIcon from '../../../../../components/Icons/ArrowForwardIcon';
import {
  CEPMaskedInput,
  CNPJMaskedInput,
} from '../../../../../components/MaskedInputs';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../../../components/Row';
import {
  clearCooperativaByCod,
  loadCooperativaByCod,
} from '../../../../../store/modules/ContratosActions';
import {
  changeContratoEntePublicoEditingValue,
  clearContratoEntePublicoEditing,
} from '../../../../../store/modules/ContratosEntePublicoActions';
import {
  loadAllEstadosByCoops,
  loadCidadesByEstadoId,
  loadCooperativas,
} from '../../../../../store/modules/LogradouroActions';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  allIsTrue,
  emailIsValid,
  EMAIL_MAX_LENGTH,
  requiredIsValid,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './DadosCooperativa.scss';
import GenericDados from './GenericDados';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-ente-publico-dados-cooperativa';

const INITIAL_STATE = {
  emailCoopChanged: false,
  codCoopChanged: false,
};

class DadosCooperativa extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        ></Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            label={this.props.languageValues.proxima}
            theme='pufvYellow'
            onClick={() => {
              if (this.formIsValid()) {
                this.toSubmit(
                  0,
                  this.props.contratosEntePublico.contratoEditing
                );
              }
            }}
            rightIcon={<ArrowForwardIcon />}
            disabled={this.submitButtonIsDisabled()}
          />
        </Col>
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    if (this.hasPermissions()) {
      return (
        this.props.loading ||
        this.props.contratos.loadingCooperativaByCod ||
        !this.formIsValid()
      );
    }
    return false;
  };

  fieldDisabled = () => {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.entePublico.edit) {
        return true;
      }
    }
    return this.props.loading;
  };

  reset = () => {
    this.props.clearContratoEntePublicoEditing();
    this.setState(INITIAL_STATE);
  };

  componentWillUnmount() {
    this.props.clearCooperativaByCod();
    this.reset();
  }

  loadCoop = (codCoop) => {
    this.props.loadCooperativaByCod(
      codCoop || this.props.contratosEntePublico.contratoEditing.codCoop
    );
  };

  UNSAFE_componentWillMount() {
    this.props.loadCooperativas(false);
  }

  emailCoopValueIsValid = () => {
    const value = this.props.contratosEntePublico.contratoEditing.emailCoop;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.email.required
    );
    const validation = emailIsValid(
      value,
      this.props.languageValues.validations.email.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      (newProps.loading !== this.props.loading && !newProps.loading) ||
      (!newProps.loading &&
        newProps.contratosEntePublico.contratoEditing.codCoop !==
          this.props.contratosEntePublico.contratoEditing.codCoop)
    ) {
      this.props.clearCooperativaByCod();
      this.loadCoop(newProps.contratosEntePublico.contratoEditing.codCoop);
    }
  }

  codCoopValueChanged = () => {
    this.setValue({
      target: {
        name: 'idEstado',
        value: '',
      },
    });
  };

  formIsValid() {
    const arr = [
      this.emailCoopValueIsValid().status,
      this.codCoopValueIsValid().status,
    ];
    return allIsTrue(arr);
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cadastroContratoDadosCooperativa}
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending:
          this.props.loading || this.props.contratos.loadingCooperativaByCod,
      },
    };
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(0, this.props.contratosEntePublico.contratoEditing);
            }
          }}
        >
          <button
            type='submit'
            className='hidden-button'
            disabled={this.submitButtonIsDisabled()}
          ></button>
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'email')}
                label={this.props.languageValues.cadastroContratoEmail}
                name='emailCoop'
                value={
                  this.props.contratosEntePublico.contratoEditing.emailCoop
                }
                onChange={this.setValue}
                counter={true}
                maxSize={EMAIL_MAX_LENGTH}
                error={!this.emailCoopValueIsValid().status}
                helperText={
                  !this.emailCoopValueIsValid().status
                    ? this.emailCoopValueIsValid().error
                    : ''
                }
                disabled={this.fieldDisabled() || this.disabledWhenDistrato()}
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'cooperativas')}
                label={this.props.languageValues.cadastroContratoCooperativa}
                placeholder={
                  this.props.logradouro.loadingCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.props.logradouro.cooperativas.map((item) => {
                  return {
                    label: item.nome,
                    value: item.codigo,
                  };
                })}
                value={this.props.contratosEntePublico.contratoEditing.codCoop}
                onChange={(value) => {
                  const currValue = value && value.value ? value.value : '';
                  this.setValue({
                    target: {
                      name: 'codCoop',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.logradouro.loadingCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                error={!this.codCoopValueIsValid().status}
                helperText={
                  !this.codCoopValueIsValid().status
                    ? this.codCoopValueIsValid().error
                    : ''
                }
                disabled={
                  this.fieldDisabled() ||
                  this.disabledWhenDistrato() ||
                  this.disabledWhenAditivo() ||
                  this.props.logradouro.loadingCooperativas
                }
              />
            </Col>
          </Row>
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'cnpj')}
                label={this.props.languageValues.cadastroContratoCNPJ}
                name='cnpjCoop'
                value={this.props.contratos.cooperativaByCod.cnpj}
                InputProps={{
                  readOnly: true,
                  inputComponent: CNPJMaskedInput,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'cep')}
                label={this.props.languageValues.cadastroContratoCep}
                name='cepCoop'
                value={this.props.contratos.cooperativaByCod.cep}
                InputProps={{
                  readOnly: true,
                  inputComponent: CEPMaskedInput,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
          </Row>
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'endereco')}
                label={this.props.languageValues.cadastroContratoEndereco}
                name='enderecoCoop'
                value={this.props.contratos.cooperativaByCod.endereco}
                InputProps={{
                  readOnly: true,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'numero')}
                label={this.props.languageValues.cadastroContratoNumero}
                name='numeroCoop'
                value={this.props.contratos.cooperativaByCod.numero}
                InputProps={{
                  readOnly: true,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
          </Row>
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'complemento')}
                label={this.props.languageValues.cadastroContratoComplemento}
                name='complementoCoop'
                value={this.props.contratos.cooperativaByCod.complemento}
                InputProps={{
                  readOnly: true,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'bairro')}
                label={this.props.languageValues.cadastroContratoBairro}
                name='bairroCoop'
                value={this.props.contratos.cooperativaByCod.bairro}
                InputProps={{
                  readOnly: true,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
          </Row>
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'estado')}
                label={this.props.languageValues.cadastroContratoEstado}
                name='estadoCoop'
                value={this.props.contratos.cooperativaByCod.uf}
                InputProps={{
                  readOnly: true,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={getElementID(rootElementId, 'cidade')}
                label={this.props.languageValues.cadastroContratoCidade}
                name='cidadeCoop'
                value={this.props.contratos.cooperativaByCod.municipio}
                InputProps={{
                  readOnly: true,
                }}
                disabled={
                  this.fieldDisabled() ||
                  !this.codCoopValueIsValid().status ||
                  this.props.contratos.loadingCooperativaByCod
                }
              />
            </Col>
          </Row>
        </form>
      </GenericCardScreen>
    );
  }
}

DadosCooperativa.propTypes = {
  ...GenericDados.propTypes,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  logradouro: state.logradouro,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadCooperativas,
      changeContratoEntePublicoEditingValue,
      clearCooperativaByCod,
      loadAllEstadosByCoops,
      loadCidadesByEstadoId,
      loadCooperativaByCod,
      clearContratoEntePublicoEditing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DadosCooperativa);
